import script from "./MediaList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaList.vue?vue&type=script&lang=ts&setup=true"

import "./MediaList.vue?vue&type=style&index=0&id=5ddc2bab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddc2bab"]])

export default __exports__